// src/api/auth.types.ts
var USER_ROLES = {
  ADMIN: "Admin",
  OPERATION_TEAM: "Operation_Team"
};
var AUTH_ERROR_CODES = {
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  UNAUTHORIZED: "UNAUTHORIZED",
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
  SESSION_EXPIRED: "SESSION_EXPIRED"
};

// src/domain/project.types.ts
var ProjectStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  ON_HOLD: "ON_HOLD"
};
var ProjectPriority = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL"
};

// src/domain/notification.types.ts
var NotificationPriority = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  URGENT: "URGENT"
};
var NotificationCategory = {
  SYSTEM: "SYSTEM",
  PROJECT: "PROJECT",
  ACCOUNT: "ACCOUNT",
  BILLING: "BILLING",
  SECURITY: "SECURITY",
  MARKETING: "MARKETING",
  SUPPORT: "SUPPORT"
};
var NotificationType = {
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  ERROR: "ERROR",
  REMINDER: "REMINDER"
};
var NotificationStatus = {
  UNREAD: "UNREAD",
  READ: "READ",
  ARCHIVED: "ARCHIVED",
  DELETED: "DELETED"
};

// src/domain/company-details.types.ts
var CompanyType = {
  PIF_ESTABLISHED: "PIF_ESTABLISHED",
  PIF_UNDER_DEVELOPMENT: "PIF_UNDER_DEVELOPMENT",
  KSA_PRIVATE: "KSA_PRIVATE",
  INTERNATIONAL: "INTERNATIONAL"
};
var KybStatus = {
  NOT_STARTED: "NOT_STARTED",
  PENDING: "PENDING",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var NdaStatus = {
  NOT_STARTED: "NOT_STARTED",
  PENDING: "PENDING",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var MsaStatus = {
  NOT_STARTED: "NOT_STARTED",
  PENDING: "PENDING",
  SOW_SUBMITTED: "SOW_SUBMITTED",
  MSA_DRAFT_RECEIVED: "MSA_DRAFT_RECEIVED",
  PENDING_TASAMA_SIGNATURE: "PENDING_TASAMA_SIGNATURE",
  ACTIVE: "ACTIVE",
  REJECTED: "REJECTED"
};
var SoftLandingStatus = {
  NOT_STARTED: "NOT_STARTED",
  REQUESTED: "REQUESTED",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED"
};

// src/domain/support-ticketing.types.ts
var TopicCategory = /* @__PURE__ */ ((TopicCategory2) => {
  TopicCategory2["GENERAL"] = "General";
  TopicCategory2["SERVICE_SPECIFIC"] = "Service Specific";
  TopicCategory2["ACTIVE_SERVICES"] = "Active Services";
  TopicCategory2["REQUESTED_SERVICES"] = "Requested Service";
  TopicCategory2["IT_SERVICES"] = "IT Services";
  TopicCategory2["ORACLE_ERP_ISSUES"] = "Oracle ERP Issues";
  return TopicCategory2;
})(TopicCategory || {});

export { AUTH_ERROR_CODES, CompanyType, KybStatus, MsaStatus, NdaStatus, NotificationCategory, NotificationPriority, NotificationStatus, NotificationType, ProjectPriority, ProjectStatus, SoftLandingStatus, TopicCategory, USER_ROLES };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map